import { ValidationContext } from "~app/common/validation/validationContext";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { ExampleUsageTexts as text } from "./example-usage.texts";

export class ExampleUsageValidation {
    static init(): ValidationContext {
        const context = new ValidationContext();
        context.create(ValidationScopes.skapa).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                id: 1,
                message: { text: text.validation.efternamn },
                model: () => null,
                name: "efternamn",
                required: true,
                triggerOnLoad: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 3,
                message: { text: text.validation.fornamn },
                model: () => null,
                name: "fornamn",
                required: true,
                triggerOnLoad: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (v) => v > 0,
                id: 2,
                message: { text: text.validation.moreThanZero },
                model: () => null,
                name: "moreThanZero",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (v) => /^\d+$/.test(v),
                id: 4,
                message: { text: text.validation.textOnlyNumbers },
                model: () => null,
                name: "textOnlyNumbers",
                required: true
            }
        ]);
        return context;
    }
}
